import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keyValue'
})
export class KeyValuePipe implements PipeTransform {

  transform(value: string, name: Array<any>): any {
    return name.filter(f => f.key === value).map(m => m.value)[0] || value;
  }

}
